import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import SmoothScroll from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Activities } from "@/components/Activities";
import { Library } from "@/components/Library";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import WorkersArea from "@/pages/WorkersArea";

const HomePage = () => (
  <SmoothScroll>
    <div className="min-h-screen bg-background text-foreground antialiased selection:bg-primary">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Activities />
        <Library />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  </SmoothScroll>
);

function AppRouter() {
  const location = useLocation();
  // O hash é lido DURANTE o render (useLocation, reativo) para processar o session_id
  // antes de qualquer verificação de sessão — evita race condition do OAuth.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/trabalhadores" element={<WorkersArea />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
